import React from 'react';
import withStaticBuilder from 'StaticBuilder/hocs/StaticBuilderField';
import PropTypes from 'prop-types';

const TextAreaField = props => (
  <textarea
    className="input-xlarge"
    id={props.id.toLowerCase()}
    name={props.id}
    rows={9}
    onChange={props.onChange}
    value={props.value}
  />
);


TextAreaField.defaultProps = {
  value: '',
};

TextAreaField.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default withStaticBuilder(TextAreaField);



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/TextAreaField.jsx